import React, { useState } from "react";
import { Dashboard as DashboardLayout } from "layouts";
import {
  RowDetailState,
  PagingState,
  IntegratedPaging,
  SearchState,
  IntegratedFiltering,
} from "@devexpress/dx-react-grid";
import {
  Grid as DataGrid,
  Table,
  TableHeaderRow,
  TableRowDetail,
  PagingPanel,
  Toolbar,
  SearchPanel,
} from "@devexpress/dx-react-grid-material-ui";
import { withRouter } from "react-router";
import compose from "recompose/compose";
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import PropTypes from "prop-types";
import {
  Typography,
  withStyles,
  Grid,
  Paper,
  CircularProgress,
} from "@material-ui/core";
import EditDealerDetails from "pages/Administration/MyDealers/EditDealerDetails";
import { GET_MY_DEALERS_SALE } from "../queries";
import moment from "moment";
import { useQuery } from "@apollo/client";
import "./myDealers.scss";
import auth from "Auth";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";

const styles = (theme) => ({
  button: {
    margin: theme.spacing(),
  },
  input: {
    display: "none",
  },
  root: {
    padding: theme.spacing(),
  },
  item: {
    height: "100%",
  },
  marginFix: {
    marginTop: 19,
    marginBottom: 10,
    marginLeft: 5,
    marginRight: 5,
  },
  gridContainer: {
    display: "flex",
    flexDirection: "column",
  },
});

const RowDetail = ({ row }) => (
  <div>
    <table cellSpacing="0" className="detailTable">
      <tbody>
        <tr>
          <td className="table_data">Dealer Name:</td>
          <td className="table_data">{row?.assign_profiles?.name}</td>
        </tr>
        <tr>
          <td className="table_data">Dealership Name:</td>
          <td className="table_data">{row?.assign_profiles?.company}</td>
        </tr>
        <tr>
          <td className="table_data">Business Email:</td>
          <td className="table_data">{row?.assign_profiles?.email}</td>
        </tr>
        <tr>
          <td className="table_data">Address:</td>
          <td className="table_data">
            {row?.assign_profiles?.address}&nbsp;
            {row?.assign_profiles?.address2}
            <br />
          </td>
        </tr>
        <tr>
          <td className="table_data">City:</td>
          <td className="table_data">{row?.assign_profiles?.city}</td>
        </tr>
        <tr>
          <td className="table_data">Zip Code:</td>
          <td className="table_data">{row?.assign_profiles?.zipcode}</td>
        </tr>
        <tr>
          <td className="table_data">Country:</td>
          <td className="table_data">{row?.assign_profiles?.country}</td>
        </tr>
        <tr>
          <td className="table_data">Region:</td>
          <td className="table_data">{row?.assign_profiles?.region}</td>
        </tr>
        <tr>
          <td className="table_data">Phone:</td>
          <td className="table_data">{row?.assign_profiles?.phone}</td>
        </tr>
      </tbody>
    </table>
  </div>
);

function MyDealers(props) {
  const { classes } = props;
  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 200,
      maxWidth: 300,
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    chip: {
      margin: 2,
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
  }));
  const [columns] = useState([
    {
      name: "created_at",
      title: "Date Added",
      getCellValue: (row) =>
        moment(row?.assign_profiles?.created_at).format("YYYY-MM-DD") || "",
    },
    {
      name: "name",
      title: "Dealer Name",
      getCellValue: (row) => row?.assign_profiles?.name || "",
    },
    {
      name: "company",
      title: "Dealership Name",
      getCellValue: (row) => row?.assign_profiles?.company || "",
    },
    {
      name: "brand",
      title: "Brand",
      getCellValue: (row) =>
        <EditDealerDetails item={row} /> ? (
          <EditDealerDetails item={row?.assign_profiles} />
        ) : undefined,
    },
    {
      name: "email",
      title: "Email",
      getCellValue: (row) => row?.assign_profiles?.email || "",
    },
  ]);

  const brandOptions = {
    "Carolina Skiff": "has_skiff",
    "Sea Chaser": "has_seachaser",
    "Fun Chaser": "has_funchaser",
  };

  const [dateColumns] = useState(["created_at"]);
  // const [filterBy, setFilterBy] = useState('name');
  // const [searchTerm, setSearchTerm] = useState("")
  const [search, setSearch] = useState("");
  const [selectedField, setSelectedField] = useState("Date Added");
  const [selectedFieldMultiple, setSelectedFieldMultiple] = useState([]);

  const [searchValue, setSearchValue] = useState("");

  // const handleOnChange = useCallback(
  //     debounce((value) => {
  //         setSearch(value)
  //     }, 1000),
  //     []
  // );

  // const getQueryVariables = () => {
  //     let where = {};
  //     const formattedSearchTerm = `%${search}%`;
  //     let comparisonValue = search;

  //     if (filterBy === 'name') {
  //         where = {
  //             _or: [{ assign_profiles: { name: { _ilike: "%" + formattedSearchTerm + "%" } } }],
  //         };
  //     } else if (filterBy === 'brand') {
  //         if (formattedSearchTerm.includes('sea') || formattedSearchTerm.includes('chaser')) {
  //             where = {
  //                 _or: [{ assign_profiles: { has_seachaser: { _eq: true } } }],
  //             };
  //         } else if (formattedSearchTerm.includes('caro') || formattedSearchTerm.includes('carolina') || formattedSearchTerm.includes('skiff')) {
  //             where = {
  //                 _or: [{ assign_profiles: { has_skiff: { _eq: true } } }],
  //             };
  //         } else if (formattedSearchTerm.includes('fun') || formattedSearchTerm.includes('chaser')) {
  //             where = {
  //                 _or: [{ assign_profiles: { has_funchaser: { _eq: true } } }],
  //             };
  //         } else if (search) {
  //             where = {
  //                 _or: [{ assign_profiles: { email: { _like: "fefdsghfsghfsjhgfsdghftefdsgdsghfsaterfytedrsfdhvc" } } }],
  //             };
  //         } else {
  //             return { where };

  //         }
  //     }
  //     else if (filterBy === 'email') {
  //         where = {
  //             _or: [{ assign_profiles: { email: { _ilike: "%" + formattedSearchTerm + "%" } } }],
  //         };
  //     }
  //     else if (filterBy === 'date') {
  //         const parsedDate = moment(comparisonValue, 'MM/DD/YYYY', true);
  //         if (parsedDate.isValid()) {
  //             comparisonValue = parsedDate.format('YYYY-MM-DD');
  //         } else {
  //             return { where };
  //         }
  //         where = {
  //             _or: [
  //                 {
  //                     created_at: {
  //                         _gte: `${comparisonValue}T00:00:00+00:00`,
  //                         _lt: `${comparisonValue}T23:59:59+00:00`,
  //                     },
  //                 },
  //             ],
  //         };
  //     }
  //     return { where };
  // }

  const getRowId = (row) => row.profile_id;

  const DateFormatter = ({ value }) => moment(value).format("MM/DD/YYYY");

  const DateTypeProvider = (props) => (
    <DataTypeProvider formatterComponent={DateFormatter} {...props} />
  );

  const { loading, data, error, refetch } = useQuery(GET_MY_DEALERS_SALE, {
    notifyOnNetworkStatusChange: true,
    variables: { profile_id: auth.getSub() },
    fetchPolicy: "cache-and-network",
  });

  const FieldDropdown = ({ fields, selectedField, onSelectField }) => (
    <select
      value={selectedField}
      onChange={(e) => onSelectField(e.target.value)}
    >
      {fields?.map((field) => (
        <option key={field} value={field}>
          {field}
        </option>
      ))}
    </select>
  );

  const FieldMultipleDropdown = ({ fields, selectedField, onSelectField }) => {
    const classes = useStyles();

    const handleChange = (event) => {
      const values = event.target.value;
      onSelectField(values);
    };

    return (
      <FormControl className={classes.formControl}>
        <InputLabel id="mutiple-chip-label">Brand</InputLabel>
        <Select
          labelId="mutiple-chip-label"
          id="mutiple-chip-select"
          multiple
          value={selectedField}
          onChange={handleChange}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {selected?.map((value) => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
        >
          {fields?.map((name) => (
            <MenuItem key={name} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  const DealerCompanyDropdown = ({ fields, selectedField, onSelectField }) => {
    const classes = useStyles();

    const handleChange = (event) => {
      const values = event.target.value;
      onSelectField(values);
    };

    return (
      <FormControl className={classes.formControl}>
        <InputLabel id="dealer-company-label">Dealer Name</InputLabel>
        <Select
          labelId="dealer-company-label"
          id="dealer-company-select"
          multiple
          value={selectedField}
          onChange={handleChange}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {selected.map((value) => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
        >
          {fields.map((name) => (
            <MenuItem key={name} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  const handleFieldChange = (selectedField) => {
    setSelectedField(selectedField);
    setSearchValue("");
    setSelectedFieldMultiple([]);
  };

  const handleFieldChangeMultiple = (selectedField) => {
    setSelectedFieldMultiple(selectedField);
    setSearchValue("");
  };

  // if (loading) return <p>Loading...</p>;
  if (error) return <p>Error {JSON.stringify(error)}</p>;

  const filteredRows = data?.sales_assign?.filter((row) => {
    let name;
    if (selectedField === "Date Added") {
      name =
        row?.[
          columns?.find((e) => e?.title === selectedField)?.name
        ]?.toLowerCase();
    } else if (selectedField !== "Brand" && selectedField !== "Dealer Name") {
      name =
        row?.assign_profiles?.[
          columns?.find((e) => e?.title === selectedField)?.name
        ]?.toLowerCase();
    } else if (selectedField === "Brand") {
      return (
        selectedFieldMultiple.length === 0 ||
        selectedFieldMultiple.some(
          (brandName) => row?.assign_profiles?.[brandOptions[brandName]]
        )
      );
    } else if (selectedField === "Dealer Name") {
      return (
        selectedFieldMultiple.length === 0 ||
        selectedFieldMultiple.includes(row?.assign_profiles?.name)
      );
    }
    const searchText = searchValue?.toLowerCase().trim();
    return (name || "").includes(searchText);
  });

  const changeSearchValue = (newValue) => {
    setSearchValue(newValue);
  };

  return (
    <DashboardLayout title="My Dealers" className="myDealers">
      <div className={classes.root + " sectionContainer"}>
        <Typography gutterBottom variant="h4" className="title">
          <span className="dealer_title">My Dealers</span>
        </Typography>

        <Paper className={classes.paper} style={{ margin: "3em" }}>
          <Grid container>
            <Grid item xs align="center">
              {/* <input
                                type="search"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    handleOnChange(e.target.value);
                                }}
                            /> */}
              <div className={classes.gridContainer}>
                {!loading ? (
                  <DataGrid rows={filteredRows || []} columns={columns}>
                    <SearchState
                      value={searchValue}
                      onValueChange={changeSearchValue}
                    />
                    <PagingState defaultCurrentPage={0} pageSize={10} />
                    <IntegratedFiltering />
                    <IntegratedPaging />
                    <RowDetailState defaultExpandedRowIds={[0]} />
                    <Table />
                    <TableHeaderRow />
                    <PagingPanel />
                    <TableRowDetail contentComponent={RowDetail} />
                    <Toolbar />

                    {/* dropdown */}
                    <div
                      className={`${
                        selectedField === "Brand" ||
                        selectedField === "Dealer Name"
                          ? "tableFilter selectbrand"
                          : "tableFilter"
                      }`}
                    >
                      <div className="wrapper">
                        <FieldDropdown
                          fields={columns?.map((column) => column?.title)}
                          selectedField={selectedField}
                          onSelectField={handleFieldChange}
                        />
                        {selectedField === "Brand" ? (
                          <FieldMultipleDropdown
                            fields={Object.keys(brandOptions)}
                            selectedField={selectedFieldMultiple}
                            onSelectField={handleFieldChangeMultiple}
                          />
                        ) : selectedField === "Dealer Name" ? (
                          <DealerCompanyDropdown
                            fields={[
                              ...new Set(
                                (data?.sales_assign || [])
                                  .map((row) => row?.assign_profiles?.name)
                                  .filter(Boolean)
                              ),
                            ]}
                            selectedField={selectedFieldMultiple}
                            onSelectField={handleFieldChangeMultiple}
                          />
                        ) : (
                          <SearchPanel />
                        )}
                      </div>
                    </div>
                  </DataGrid>
                ) : (
                  <div className={classes.loadingOverlay}>
                    <CircularProgress />
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        </Paper>
      </div>
    </DashboardLayout>
  );
}

MyDealers.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(withRouter, withStyles(styles))(MyDealers);
